import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
import Component from '@glimmer/component';

import type PopupContext from 'webapp/models-custom/popup/context';
import type PopupModal from 'webapp/models-custom/popup/modal';

export interface Args {
	model: PopupModal | PopupContext;
}

export default abstract class PopupInnerBaseComponent<T extends Args> extends Component<T> {
	@action
	reposition(): void {
		this.args.model.reposition();
	}

	@action
	scheduleReposition(): void {
		scheduleOnce('afterRender', this, this.reposition);
	}

	@action
	close(): void {
		void this.args.model.close();
	}
}
